module.exports = __webpack_public_path__ + "img/page1-4.df08a364.png";